<template>
  <div v-if="userAccount" class="sm-settings">
    <div class="sm-wrap sm">
      <breadcrumbs-block :crumbs="breadcrumbs" />
      <settings-top />
      <settings-main />
    </div>
  </div>
  <sm-spinner v-else :show="!userAccount" />
</template>

<script>
import Top from '@/views/admin/pages/settings/Top.vue';
import Main from '@/views/admin/pages/settings/Main.vue';
import { mapGetters } from 'vuex';
import Spinner from '@/components/Spinner';
import Breadcrumbs from '@/components/Breadcrumbs';

export default {
  name: 'settings',
  components: {
    'settings-top': Top,
    'settings-main': Main,
    'sm-spinner': Spinner,
    'breadcrumbs-block': Breadcrumbs,
  },
  data() {
    return {
      breadcrumbs: [
        {
          link: 'settings',
          name: 'admin-settings',
          text: 'Settings',
          current: true
        }
      ]
    };
  },
  computed: {
    ...mapGetters({
      userAccount: 'account/userAccount',
    })
  },
  created() {
    if (this.userAccount.role == "mail_admin") {
      this.$router.push("/")
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/scss/general/mixins.scss';
@import '@/assets/scss/framework/scss-variables.scss';
@import '@/assets/scss/pages/common/settings/_settings.scss';
</style>
